// Whether the hash has been handled for the current page load.
// This is used to prevent the hash from being handled multiple times.
let hashHandled = false;

function initAccordions() {
	document
		.querySelectorAll('.wp-block-cancan-accordion')
		.forEach((accordion) => {
			const contextData = accordion.dataset.context;
			const context = contextData ? JSON.parse(contextData) : {};
			const autoclose = context.autoclose || false;

			const accordionItems = accordion.querySelectorAll(
				'.wp-block-cancan-accordion-item'
			);

			if (accordionItems.length === 0) return;

			accordionItems.forEach((accordionItem) => {
				const toggle = accordionItem.querySelector(
					'.wp-block-cancan-accordion-heading__toggle'
				);

				if (!toggle) return;

				const panelId = toggle.getAttribute('aria-controls');
				const controlledPanel = panelId
					? document.getElementById(panelId)
					: null;

				if (!controlledPanel) return;

				accordionItem.animateOpen = () => {
					// Kill any ongoing animation
					if (accordionItem.currentTween) {
						accordionItem.currentTween.kill();
					}

					// If currently fully hidden, lock the height to 0 first so we animate from 0
					if (controlledPanel.getAttribute('hidden') === 'true') {
						controlledPanel.style.height = '0px';
					}

					controlledPanel.removeAttribute('hidden');
					toggle.setAttribute('aria-expanded', 'true');

					accordionItem.currentTween = gsap.to(controlledPanel, {
						height: controlledPanel.scrollHeight,
						duration: 0.5,
						ease: 'power2.out',
						onComplete: () => {
							accordionItem.currentTween = null;
							controlledPanel.style.height = 'auto';
						},
					});
				};

				accordionItem.animateClose = () => {
					// Kill any ongoing animation
					if (accordionItem.currentTween) {
						accordionItem.currentTween.kill();
					}

					toggle.setAttribute('aria-expanded', 'false');

					// If the panel is currently fully open (height is auto),
					// pin it to pixel height first so it animates smoothly to 0
					if (
						controlledPanel.style.height === 'auto' ||
						controlledPanel.style.height === ''
					) {
						controlledPanel.style.height =
							controlledPanel.scrollHeight + 'px';
					}

					accordionItem.currentTween = gsap.to(controlledPanel, {
						height: 0,
						duration: 0.3,
						ease: 'power2.out',
						onComplete: () => {
							accordionItem.currentTween = null;
							controlledPanel.setAttribute('hidden', 'true');
						},
					});
				};

				toggle.addEventListener('click', () => {
					const isClosed =
						controlledPanel.getAttribute('hidden') === 'true' ||
						toggle.getAttribute('aria-expanded') === 'false';

					if (isClosed) {
						// If autoclose is enabled, close all other panels in this accordion
						if (autoclose) {
							accordionItems.forEach((otherItem) => {
								if (otherItem !== accordionItem) {
									const otherToggle = otherItem.querySelector(
										'.wp-block-cancan-accordion-heading__toggle'
									);
									if (
										otherToggle &&
										otherToggle.getAttribute(
											'aria-expanded'
										) === 'true'
									) {
										if (
											typeof otherItem.animateClose ===
											'function'
										) {
											otherItem.animateClose();
										}
									}
								}
							});
						}

						accordionItem.animateOpen();
					} else {
						accordionItem.animateClose();
					}
				});
			});
		});
}

document.addEventListener('DOMContentLoaded', initAccordions);
